export default "<div id=\"cayuse-common-header\" ></div>"